var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"topBg"},[_c('img',{attrs:{"src":require("@/assets/home/background1.png"),"alt":""}}),_c('div',{staticClass:"contents"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.titles))]),_vm._l((_vm.smalls),function(item,index){return _c('p',{key:index,staticClass:"small"},[_vm._v(_vm._s(item))])})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }